import React, { useState } from 'react';
import Modal from '@/components/common/modal/Modal';
import Button from '@/components/common/button/Button';
import DataSelect from '@/components/common/select/DataSelect';
import type { simulationSelectorModalProps } from './types.props';


const SimulationSelectorModal: React.FC<simulationSelectorModalProps> = ({
    isOpen,
    simulations,
    isLoading,
    onClose,
    onConfirm,
}) => {
    const [selectedSimId, setSelectedSimId] = useState<string>('');

    const simulationOptions = simulations.map(sim => ({
        value: String(sim.id),
        label: sim.name,
    }));

    const handleConfirm = () => {
        if (selectedSimId) {
            onConfirm(selectedSimId);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <h2>Seleccionar Simulacro</h2>
            <p style={{ margin: '1rem 0' }}>
                Por favor, elige el simulacro del cual deseas generar el reporte de estudiantes.
            </p>
            <DataSelect
                label="Simulacros con resultados"
                name="simulation-selector"
                options={simulationOptions}
                value={selectedSimId}
                onChange={(e) => setSelectedSimId(e.target.value)}
                disabled={isLoading || simulations.length === 0}
                placeholder={isLoading ? "Cargando..." : "Elige un simulacro"}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '2rem' }}>
                <Button variant="secondary" onClick={onClose}>Cancelar</Button>
                <Button onClick={handleConfirm} disabled={!selectedSimId || isLoading}>
                    Descargar reporte
                </Button>
            </div>
        </Modal>
    );
};

export default SimulationSelectorModal;
